import React, { useEffect, useState } from 'react';
import { useAppDispatch } from 'hooks';
import { Progress } from 'reactstrap';

import ErrorResponse from '~components/ErrorResponse';
import Icon, { faCircleCheck } from '~components/icon';

import { bulkUpdate } from '~appointments/actions/utilities/bulkUpdatePackages';

interface ComponentProps {
  value: any;
}

const Confirm: React.FC<ComponentProps> = ({ value }) => {
  const dispatch = useAppDispatch();
  const [isProcessing, setIsProcessing] = useState(true);
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    update();
  }, []);

  const update = async () => {
    setIsProcessing(true);

    const { payload, error } = await dispatch(bulkUpdate(value));
    const { success } = payload ?? {};
    if (success) {
      setIsSuccess(true);
    } else {
      setErrorMessage(error?.message ?? 'Something unexpected happened, please contact your administrator');
    }

    setIsProcessing(false);
  };

  return (
    <div>
      <ErrorResponse message={errorMessage} />
      {isProcessing && (
        <Progress className="text-center w-100" color="success" style={{ height: '25px' }} value={100} animated>
          Processing
        </Progress>
      )}
      {isSuccess && (
        <div className="mx-4 text-center">
          <Icon icon={faCircleCheck} size="3x" className="text-success" />
          <h3 className="mt-3">Success!</h3>
        </div>
      )}
    </div>
  );
};

export default Confirm;
